import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo">
            <div className="footer-logo-icon">💰</div>
            <h4>VAT Calculator</h4>
          </div>
          <p>Our mission is to provide fast, accurate, and easy-to-use VAT calculation tools for businesses and individuals worldwide. Calculate with confidence!</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <a href="#calculator" onClick={(e) => handleSmoothScroll(e, '#calculator')}>Calculator</a>
          <a href="#features" onClick={(e) => handleSmoothScroll(e, '#features')}>Features</a>
          <a href="#how-it-works" onClick={(e) => handleSmoothScroll(e, '#how-it-works')}>How It Works</a>
        </div>

        <div className="footer-section">
          <h4>Resources</h4>
          <Link to="/about">About Us</Link>
          <a href="#faq" onClick={(e) => handleSmoothScroll(e, '#faq')}>FAQ</a>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <Link to="/contact">Contact Us</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy;2026 VAT Calculator. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
